import axios from 'axios';
import router from '@/router';
import ViewUI from 'view-design';
/** axios 请求连接等待时间 * */
axios.defaults.timeout = 300000;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
/** axios Request 配置 * */
axios.interceptors.request.use(
  (config) => config,
  (error) =>
    // 对请求错误做些什么
    // eslint-disable-next-line implicit-arrow-linebreak
    Promise.reject(error),

);
/** axios Response 配置 * */
axios.interceptors.response.use(
  (response) => {
    // eslint-disable-next-line eqeqeq
    if (response.data.code == 401) {
      router.replace({
        path: 'login',
      });
      ViewUI.LoadingBar.finish();
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject('未登陆');
    }
    return response;
  },
  (error) => Promise.reject(error),
);
export default axios;
